import { Injectable } from '@angular/core';
import { CustomerModel } from '@df/session/api/customer.model';
import { STAFF_CUSTOMER_GROUP_ID, STORE_STAFF_CUSTOMER_GROUP_ID } from '../groups/customer-groups';

@Injectable({
    providedIn: 'root'
})
export class CustomerModelDecorator extends CustomerModel {
    get isStaff(): boolean {
        const groupId = this.data?.group_id;

        return [STAFF_CUSTOMER_GROUP_ID, STORE_STAFF_CUSTOMER_GROUP_ID].indexOf(groupId) > -1;
    }
}
